<template>
  <a-modal title="My Team"
           :visible="visible"
           width="90%"
           @ok="close"
           @cancel="close"
           style="top: 20px;">
    <a-spin :spinning="loading">
      <a-row>
        <a-card hoverable v-if="showJefe">
          <a-card-meta>
            <a-spin slot="avatar" :spinning="jefeLoading">
              <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
              <a-avatar
                :src="profiles[jefe.id_person]"
              />
            </a-spin>
            <div slot="title">
              <img style="max-width: 20px; margin-top: -4px;"
                   :src="flags[jefe.nacionalidad]"
                   alt=""/>
              {{jefe.nombre}}
            </div>
            <div slot="description">
              <a-icon type="idcard" theme="twoTone"/>
              {{jefe.cargo}}
              <br/>
              <a-icon type="calendar" theme="twoTone"/>
              {{jefe.fecha_ingreso}}
              <br/>
              <template v-if="jefe.extra">
                <a-icon :type="jefe.extra_icon" style="color: red"/>
                {{jefe.extra}}
              </template>
            </div>
          </a-card-meta>
        </a-card>
      </a-row>
      <a-divider>MI EQUIPO DE TRABAJO</a-divider>
      <a-row :gutter="[16,16]">
        <a-col :sm="24" :md="8" v-for="persona in personas">
          <a-card hoverable style="min-height: 140px;">
            <a-card-meta>
              <a-spin slot="avatar"
                      :spinning="persona.loading !== false">
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
                <a-avatar
                  :src="profiles[persona.id_person]"
                />
              </a-spin>
              <div slot="title">
                <img style="max-width: 20px; margin-top: -4px;"
                     :src="flags[persona.nacionalidad]"
                     alt=""/>
                {{persona.nombre}} {{profileLoading[persona.id_person]}}
              </div>
              <div slot="description">
                <a-icon type="idcard" theme="twoTone"/>
                {{persona.cargo}}
                <br/>
                <a-icon type="calendar" theme="twoTone"/>
                {{persona.fecha_ingreso}}
                <br/>
                <template v-if="persona.extra">
                  <a-icon :type="persona.extra_icon" style="color: red"/>
                  {{persona.extra}}
                </template>
              </div>
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
  </a-modal>
</template>
<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from '../../../GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        personas: [],
        loading: false,
        jefe: {},
        profileSrc: require('CustomModules/GlobalBPOCore/assets/anon_profile.png'),
        profiles: {},
        profileLoading: {},
        jefeLoading: true,
        flags: FLAGS
      }
    },
    props: ['visible'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.cargarPersonas()
    },
    methods: {
      cargarPersonas () {
        this.loading = true
        this.httpClient.getInstance().get('ss/dashboard/my_team/consulta_team')
          .then(response => {
            this.personas = response.data
            this.loadProfilePictures()
            this.loading = false
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar la información.')
          })

        this.httpClient.getInstance().get('ss/dashboard/my_team/consulta_jefe')
          .then(response => {
            this.jefe = response.data
            this.loadProfileSrc(this.jefe, () => {
              this.jefeLoading = false
              this.loading = false
            })
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar la información del jefe.')
          })
      },
      close () {
        this.$emit('ok')
      },
      loadProfilePictures () {
        let loadPic = (index) => {
          if (this.personas.length > index) {
            let p = this.personas[index]
            p.loading = true
            this.loadProfileSrc(p,
              () => {
                p.loading = false
                this.$forceUpdate()
                loadPic(index + 1)
              })
          }
        }

        loadPic(0)
      },
      loadProfileSrc (persona, callback) {
        this.httpClient.getInstance().get('picture_service/render/profile/' + persona.id_person, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profiles[persona.id_person] = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            this.profiles[persona.id_person] = this.profileSrc
          })
          .then(callback)
      }
    },
    computed: {
      showJefe () {
        return !JsUtils.isEmpty(this.jefe)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/ModalMyTeam.vue